import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { FormattedMessage } from 'react-intl';

import messages from '../../messages';
import Button from '../../../components/Button/Button';

export default function ModalNotice(props) {
  const { isOpen, onClose } = props;
  return (
    <Modal
      style={customStyles}
      ariaHideApp={false}
      isOpen={isOpen}
    >
      <div id="full_description">
        <div
          className="justify-content-between"
          style={{
            textAlign: 'center',
            fontSize: 18,
          }}
        >
          <FormattedMessage {...messages.notice} />
        </div>
      </div>
      <div className="row justify-content-center mt-10">
        <div className="col-auto">
          <Button
            backgroundColor="#44b4a6"
            hoverBackgroundColor="#3e9e92"
            padding="13px 25px"
            borderRadius="8px"
            borderColor="transparent"
            fontSize="1em"
            onClick={onClose}
          >
            OK
          </Button>
        </div>
      </div>
    </Modal>
  );
}

ModalNotice.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    color: '#000',
    width: '80%,',
    textAlign: 'left',
    maxWidth: 600,
    borderRadius: 20,
    borderWidth: 2,
    borderStyle: 'solid',
    borderColor: '#b4b4b4',
    minWidth: 400,
  },
  overlay: {
    backgroundColor: 'rgba(0,0,0,.75)',
  },
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step14/components/ModalNotice/index.js